(function () {
    'use strict';

    angular
        .module('aeroLineCrew')
        .constant('AppVersion', {
            VERSION: 'vcrew002.3.167.1',
        });
}());
